import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetPortfolioEventByUidApiResponseSchema = z.object({
    data: z.object({
        documentId: z.string(),
        name: z.string(),
        description: z.any().optional().nullable(),
        images: z.array(
            z.object({
                url: z.string(),
            }),
        ).optional().nullable(),
        place: z.string().optional().nullable(),
        format: z.string().optional().nullable(),
        guestsCount: z.number().optional().nullable(),
        date: z.string().optional().nullable(),
        organizer: z.string().optional().nullable(),
        category: z.object({
            documentId: z.string(),
            name: z.string(),
            slug: z.string(),
        }).optional().nullable(),
        slug: z.string(),
    }),
});

type GetPortfolioEventByUidApiResponse
    = ApiResponse<z.infer<typeof GetPortfolioEventByUidApiResponseSchema>>
    | BaseError;

type GetPortfolioEventByUidActionRequest = {
    uid: string,
}

export const getPortfolioEventByUid = createAsyncThunk<
    GetPortfolioEventByUidApiResponse,
    GetPortfolioEventByUidActionRequest
>(
    'PortfolioEventPageActionsGetPortfolioEventByUid',
    async ({
        uid,
    }) => apiInstance.get(
        `/s/portfolio-events/${uid}`,
        {
            'populate[images][fields]': 'url',
            'populate[category][fields]': '*',
        },
        GetPortfolioEventByUidApiResponseSchema,
    ),
);
